jQuery( document ).ready(function() {

    if($('.listcategorycollections_cards').length > 0) {
  
      $(".listcategorycollections_card").slice(0, 5).show();

      $(".listcategorycollections_showmore").on('click', function(e) {
        e.preventDefault();

        $(".listcategorycollections_card:hidden").slice(0, 5).slideDown();
        if ($(".listcategorycollections_card:hidden").length == 0) {
          $(".listcategorycollections_showmore").fadeOut('slow');
        }
      });
  
    }


    /* filtre date */

    function filterDate(){
      var selectDrop = $(".select-year-category");
      var allReal = $('.listcategorycollections_card');
      var thematique;
      var allItem = allReal.length;
      selectDrop.on("change", function () {
        thematique = this.value;
        console.log(thematique);
        allReal.hide();
        $('.listcategorycollections_showmore').hide()
        var thematiqueItem = $(".item" + thematique).length;
        allItem = thematiqueItem;
        if (thematique == "all") {
          $(".listcategorycollections_card").slice(0, 5).show();
          $('.listcategorycollections_showmore').show()
        } else {
          $(
            ".item_" + thematique ).show();
        }
      });
    }
    filterDate();

  
  });